import React, { useState, useEffect } from "react";
import { Table, Popconfirm, message } from "antd";
import { AiFillDelete } from "react-icons/ai";
import axios from "axios";

const ReviewsList = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const response = await axios.get(
        "https://backend.gulabidecor.com/api/reviews/getAllReviews"
      );
      console.log(response);  // Log the full response

      // Adjust the mapping based on the actual API response structure
      const formattedData = response.data.reviews.map((review) => ({
        key: review.review_id,
        name: review.user_name,  // Use 'user_name' from the API response
        rating: review.rating,
        comment: review.comment,
      }));
      setReviews(formattedData);
    } catch (err) {
      console.error("Error fetching reviews:", err.message);
    }
  };

  const handleDelete = async (reviewId) => {
    try {
      await axios.delete(
        `https://backend.gulabidecor.com/api/reviews/deleteReviews/${reviewId}`
      );
      message.success("Review deleted successfully.");
      fetchReviews();
    } catch (err) {
      console.error("Error deleting review:", err.message);
      message.error("Failed to delete review.");
    }
  };

  const columns = [
    {
      title: "Customer Name",
      dataIndex: "name",
    },
    {
      title: "Rating",
      dataIndex: "rating",
    },
    {
      title: "Comment",
      dataIndex: "comment",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Popconfirm
          title="Are you sure you want to delete this review?"
          onConfirm={() => handleDelete(record.key)}
          okText="Yes"
          cancelText="No"
        >
          <AiFillDelete className="action-icon text-danger" />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <h3 className="mb-4 title">Customer Reviews</h3>
      <Table columns={columns} dataSource={reviews} />
    </div>
  );
};

export default ReviewsList;
